import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TimeDkeyEasyInIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M14.48 12.311C14.336 12.129 14.336 11.872 14.48 11.69L21.52 2.811C21.78 2.483 21.546 2 21.128 2H12.577C12.312 2 12.057 2.105 11.87 2.293L2.51701 11.646C2.32201 11.841 2.32201 12.158 2.51701 12.353L11.871 21.707C12.059 21.895 12.313 22 12.578 22H21.129C21.547 22 21.781 21.517 21.521 21.189L14.481 12.31L14.48 12.311Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TimeDkeyEasyInIcon.displayName = 'TimeDkeyEasyInIcon';
